"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Invoice = _interopRequireDefault(require("../model/Invoice"));
var _InvoicePdf = _interopRequireDefault(require("../model/InvoicePdf"));
var _Message = _interopRequireDefault(require("../model/Message"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Invoice service.
* @module api/InvoiceApi
* @version 3.0
*/
var InvoiceApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new InvoiceApi. 
  * @alias module:api/InvoiceApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function InvoiceApi(apiClient) {
    _classCallCheck(this, InvoiceApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Gets an Invoice on a service
   * Gets the Invoice details for a specific Invoice on a Service.
   * @param {Number} accountId ID of the account
   * @param {Number} serviceId ID of the service
   * @param {Number} invoiceId ID of the invoice
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Invoice} and HTTP response
   */
  return _createClass(InvoiceApi, [{
    key: "getServiceInvoiceWithHttpInfo",
    value: function getServiceInvoiceWithHttpInfo(accountId, serviceId, invoiceId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServiceInvoice");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServiceInvoice");
      }
      // verify the required parameter 'invoiceId' is set
      if (invoiceId === undefined || invoiceId === null) {
        throw new Error("Missing the required parameter 'invoiceId' when calling getServiceInvoice");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId,
        'invoiceId': invoiceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Invoice["default"];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/invoices/{invoiceId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets an Invoice on a service
     * Gets the Invoice details for a specific Invoice on a Service.
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @param {Number} invoiceId ID of the invoice
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Invoice}
     */
  }, {
    key: "getServiceInvoice",
    value: function getServiceInvoice(accountId, serviceId, invoiceId) {
      return this.getServiceInvoiceWithHttpInfo(accountId, serviceId, invoiceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Invoice PDF on a Service
     * Gets the specific Invoice PDF on a Service.<br>The Invoice PDF is returned as a Byte String which will need to be converted into a PDF file to be displayed correctly.<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @param {Number} invoiceId ID of the invoice
     * @param {Number} pdfId ID of the pdf
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InvoicePdf} and HTTP response
     */
  }, {
    key: "getServiceInvoicePdfWithHttpInfo",
    value: function getServiceInvoicePdfWithHttpInfo(accountId, serviceId, invoiceId, pdfId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServiceInvoicePdf");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServiceInvoicePdf");
      }
      // verify the required parameter 'invoiceId' is set
      if (invoiceId === undefined || invoiceId === null) {
        throw new Error("Missing the required parameter 'invoiceId' when calling getServiceInvoicePdf");
      }
      // verify the required parameter 'pdfId' is set
      if (pdfId === undefined || pdfId === null) {
        throw new Error("Missing the required parameter 'pdfId' when calling getServiceInvoicePdf");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId,
        'invoiceId': invoiceId,
        'pdfId': pdfId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _InvoicePdf["default"];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/invoices/{invoiceId}/pdfs/{pdfId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Invoice PDF on a Service
     * Gets the specific Invoice PDF on a Service.<br>The Invoice PDF is returned as a Byte String which will need to be converted into a PDF file to be displayed correctly.<br>
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @param {Number} invoiceId ID of the invoice
     * @param {Number} pdfId ID of the pdf
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InvoicePdf}
     */
  }, {
    key: "getServiceInvoicePdf",
    value: function getServiceInvoicePdf(accountId, serviceId, invoiceId, pdfId) {
      return this.getServiceInvoicePdfWithHttpInfo(accountId, serviceId, invoiceId, pdfId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Invoice PDFs on a Service
     * Gets the list of all the PDFs for an Invoice on the selected Service.
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @param {Number} invoiceId ID of the invoice
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/InvoicePdf>} and HTTP response
     */
  }, {
    key: "getServiceInvoicePdfsWithHttpInfo",
    value: function getServiceInvoicePdfsWithHttpInfo(accountId, serviceId, invoiceId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServiceInvoicePdfs");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServiceInvoicePdfs");
      }
      // verify the required parameter 'invoiceId' is set
      if (invoiceId === undefined || invoiceId === null) {
        throw new Error("Missing the required parameter 'invoiceId' when calling getServiceInvoicePdfs");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId,
        'invoiceId': invoiceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_InvoicePdf["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/invoices/{invoiceId}/pdfs', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Invoice PDFs on a Service
     * Gets the list of all the PDFs for an Invoice on the selected Service.
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @param {Number} invoiceId ID of the invoice
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/InvoicePdf>}
     */
  }, {
    key: "getServiceInvoicePdfs",
    value: function getServiceInvoicePdfs(accountId, serviceId, invoiceId) {
      return this.getServiceInvoicePdfsWithHttpInfo(accountId, serviceId, invoiceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List of Service Invoices.
     * Get a list of all Invoices on a Service.
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Invoice>} and HTTP response
     */
  }, {
    key: "getServiceInvoicesWithHttpInfo",
    value: function getServiceInvoicesWithHttpInfo(accountId, serviceId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServiceInvoices");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getServiceInvoices");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Invoice["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}/invoices', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List of Service Invoices.
     * Get a list of all Invoices on a Service.
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Invoice>}
     */
  }, {
    key: "getServiceInvoices",
    value: function getServiceInvoices(accountId, serviceId) {
      return this.getServiceInvoicesWithHttpInfo(accountId, serviceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();